import { render, staticRenderFns } from "./JudgeInfoHs.vue?vue&type=template&id=0f6d9188&scoped=true"
import script from "./JudgeInfoHs.vue?vue&type=script&lang=js"
export * from "./JudgeInfoHs.vue?vue&type=script&lang=js"
import style0 from "./JudgeInfoHs.vue?vue&type=style&index=0&id=0f6d9188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6d9188",
  null
  
)

export default component.exports